module.exports = __webpack_public_path__ + "media/slow.03cb8a8e.mp4";